Vue.component("MpNewsTabs", {
    props: {
        labels: Array,
        sources: Array,
        defaultTab: Number,
    },
    data: function() {
        return {
            RESPONSE_OK: 'OK',
            RESPONSE_KO: 'KO',
            SOURCE_BASE_URL: '/news/getnews/scope/',

            currentTab: -1,
            tabsData: [],
        };
    },
    computed: {
        newsList: function() {
            return this.tabsData[this.currentTab];
        }
    },
    methods: {

        showTab: function(tabIndex) {
            if (tabIndex === this.currentTab) {
                return;
            }

            this.currentTab = tabIndex;
        },

        onSourceDataLoad: function(index, response) {
            if (response.status !== 200) {
                return;
            }

            this.tabsData[index] = response.data.news;

            if (index === this.defaultTab) {
                this.currentTab = index;
            }
        },

        loadTabContents: function() {
            var i;

            for (i=0; i<this.sources.length; i++) {
                axios
                    .get(this.SOURCE_BASE_URL+this.sources[i])
                    .then(this.onSourceDataLoad.bind(null, i))
                    .catch(function(error) {
                        console.log(error);
                    });
            }
        },

        init: function() {
            this.loadTabContents();
        }
    },

    mounted: function() {
        this.init();
    },

    updated: function() {},

    template: '\
    <section class="tabs">\
        <div class="tabs__list-wrapper">\
            <ul class="tabs__list">\
                <li class="tabs__item" v-for="(tab, index) in this.labels">\
                    <a class="tabs__link" :class="{\'tabs__link--selected\': index===currentTab}" href="#" @click.prevent="showTab(index)">{{tab}}</a>\
                </li>\
            </ul>\
        </div>\
\
        <div class="tabs__content tabs__content--padded">\
            <ul class="link-list">\
                <li class="link-list__item" v-for="newItem in newsList">\
                    <a class="link-list__link" :href="newItem.uri">\
                        <div class="link-list__icon icon icon--sm">\
                            <svg class="icon__inner" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M24 0H0v24h24z"/><path fill="currentColor" fill-rule="nonzero" d="M7.571 7v5.677h6.526V9.533l3.406 3.406-3.406 3.406v-3.1H7V7z"/><path d="M0 0h24v24H0z"/></g></svg>\
                        </div>\
                        <p class="link-list__text">{{newItem.title}}</p>\
                    </a>\
                </li>\
            </ul>\
        </div>\
    </section>',
});